import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 bg-onyx text-alabaster/60 border-t border-alabaster/10 py-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="font-serif text-xl text-alabaster">
          Onyx <span className="text-ochre-light">&amp;</span> Ochre
        </div>
        <div className="font-mono text-[10px] tracking-[0.2em] uppercase">
          © {new Date().getFullYear()} Su Dharmapala · All rights reserved
        </div>
        <Link
          to="/admin/login"
          data-testid="footer-admin-link"
          className="font-mono text-[10px] tracking-[0.2em] uppercase link-underline"
        >
          Studio Login
        </Link>
      </div>
    </footer>
  );
}
